









import Vue from 'vue'
import { IconDefinition, library } from '@fortawesome/fontawesome-svg-core'
import { faEnvelope, faLock } from '@fortawesome/free-solid-svg-icons'
import { faFacebookF } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

// add icon to use
library.add(faEnvelope, faLock, faFacebookF as IconDefinition)

const fabs = ['facebook-f']

export default Vue.extend({
  name: 'FaIcon',
  components: { FontAwesomeIcon },
  props: {
    name: {
      type: String,
      required: true,
    },
  },
  computed: {
    icon() {
      const icon = { iconName: this.name }
      if (fabs.includes(this.name as string)) {
        return { prefix: 'fab', ...icon }
      }
      return icon
    },
  },
})
